import axios from 'axios';
import config from '../config/config';

import {
    TABLET_START_SYNC,
    TABLET_RECEIVE_SYNC,
    TABLET_RECEIVE_SYNC_ERROR,
    TABLET_SET_TIME_SLOT,
    TABLET_SET_ROUTE,
    TABLET_SET_SUPPORTER_AVAILABLE,
    TABLET_CHECK_IN_SUPPORTER,
    TABLET_ADD_SUPPORTER_TO_SHIFT
} from "../config/actions";

export function startSync() {
    return (dispatch, getState) => {
        let actions = getState().tablet.actions;
        for(let i = 0; i < actions.length; i++) {
            actions[i].sentToServer = true
        }
        dispatch({
            type: TABLET_START_SYNC
        });
        axios(config.server.endpoint + 'backend/tablet/', {
            method: 'post',
            data: {
                actions: actions
            }
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: TABLET_RECEIVE_SYNC,
                    data: response.data.data
                });
            }
        }).catch(() => {
            dispatch({
                type: TABLET_RECEIVE_SYNC_ERROR
            });
        })
    }
}

export function setTimeSlot(value) {
    return {
        type: TABLET_SET_TIME_SLOT,
        data: value
    }
}

export function setRoute(value) {
    return {
        type: TABLET_SET_ROUTE,
        data: value
    }
}

export function setSupporterAvailable(supporter) {
    return {
        type: TABLET_SET_SUPPORTER_AVAILABLE,
        data: {
            supporter: supporter
        }
    }
}

export function checkInSupporter(supporter, shiftId) {
    return {
        type: TABLET_CHECK_IN_SUPPORTER,
        data: {
            supporter: supporter,
            shiftId: shiftId
        }
    }
}

export function addSupporterToShift(supporterId, shift) {
    return {
        type: TABLET_ADD_SUPPORTER_TO_SHIFT,
        supporterId: supporterId,
        shift: shift
    }
}